module.exports = "//__CDN_HOST__/2.0.8/img/banner-m.a79410ad.png";